import axios from "axios";
import { sendGet, sendPost } from "./handle-request";

const enviroment = "production"; // develop,production
// const urlBase = "https://webqa03.afphabitat.com.pe/privado/admin/investments/home/api";
// const urlBase = "https://webdesa03.afphabitat.com.pe/privado/admin/investments/home/api";
const urlBase = "https://www.afphabitat.com.pe/privado/admin/investments/home/api";
const urlBaseAzure = process.env.REACT_APP_API_URL;
class GeneralService {
    constructor() {
        // this.apiUrl = `https://${window.location.hostname}`;
        // this.apiUrl = "https://webqa03.afphabitat.com.pe";
        // this.apiUrl = "https://webdesa03.afphabitat.com.pe";
        this.apiUrl = "https://www.afphabitat.com.pe";
        this.CancelToken = axios.CancelToken;
        this.source = this.CancelToken.source();
        this.config = {
            headers: { "Access-Control-Allow-Origin": "*" },
        };
    }

    getGeneralData = async () => {
        let resultado;
        if (enviroment !== "develop") {
            // aquí la variable esta apuntando a producción entonces esta consumiendo el servicio de la nuve
            resultado = await axios.get(`${urlBaseAzure}/privado/investments/home/api`);
            resultado = resultado.data;
        } else {
            // en caso quieres consumir el dummy que cree cambia el enviromen a develop
            resultado = await require("../dummy/dummy.json");
        }
        return resultado;
    };

    getHash = async () => {
        const uri = `${this.apiUrl}/privado/hash`;
        const data = {};
        const { config } = this;
        if (enviroment !== "develop") {
            return sendGet(uri, data, config);
        } else {
            return { hash: "8c19b71855cd167e12b55115c961f5be" };
        }
    };

    getFeeValue = async (hash, date) => {
        const uri = `${this.apiUrl}/privado/admin/investments/home/api/fee_values`;
        const formData = new FormData();
        formData.set("csrf_habitat", hash);
        formData.set("fecha", date);
        const data = formData;
        const config = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
            },
        };
        if (enviroment !== "develop") {
            return sendPost(uri, data, config);
        } else {
            // const dummy = await require('../services/dummyRespuestaPeriodo.json');
            // return dummy;
        }
    };

    getTwelveMonth = async (hash) => {
        const uri = `${this.apiUrl}/privado/admin/investments/home/api/val_12`;
        const formData = new FormData();
        formData.set("csrf_habitat", hash);
        const data = formData;
        const config = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
            },
        };
        if (enviroment !== "develop") {
            return sendPost(uri, data, config);
        } else {
            // const dummy = await require('../services/dummydocemeses.json');
            // return dummy;
        }
    };

    getFeeInputs = async () => {
        let resultado;
        if (enviroment !== "develop") {
            // aquí la variable esta apuntando a producción entonces esta consumiendo el servicio de la nuve
            resultado = await axios.get(`${urlBaseAzure}/privado/investments/home/api/fee_inputs`);
            resultado = resultado.data;
        } else {
            // en caso quieres consumir el dummy que cree cambia el enviromen a develop
            resultado = await require("../dummy/fee_inputs.json");
        }
        return resultado;
    };

    cancelRequests = async () => {
        this.source.cancel("component unmount");
    };
}

export default GeneralService;
